import { FC, useState } from 'react'
import { Form, Input, Button, Row, Col, Select } from 'antd'
import styles from './index.module.scss'
import CategorySelect from '../CategorySelect'
import { connect } from 'react-redux'
export interface FromData {
  name?: string
  brandId?: string
  categoryId?: string
  standardProductId?: string
  productId?: string
}

interface HeaderProps {
  onQuery?: (formData: FromData) => void
  onAdd?: () => void
  onImport?: () => void
  brandList: Record<string, any>
  onViewTasks: () => Promise<Boolean>
}

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
}


const Header: FC<HeaderProps> = ({ onAdd, onQuery, brandList, onImport, onViewTasks }) => {
  const [pending, setPending] = useState(false)

  const onFinish = (formData: FromData) => {
    onQuery?.(formData)
  }

  const addHandler = () => {
    onAdd?.()
  }

  const importHandler = () => {
    onImport?.()
  }

  const viewTasksHandler = () => {
    setPending(true)
    onViewTasks().finally(() => setPending(false))
  }

  return (
    <Form className={styles.wrapper} onFinish={onFinish} {...layout}>
      <Row>
        <Col span={6}>
          <Form.Item name="name" label="英文名称">
            <Input placeholder="英文名称" allowClear />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="brandId" label="品牌">
            <Select placeholder="品牌" showSearch allowClear optionFilterProp="children">
              {Object.keys(brandList).map(brandId => (
                <Select.Option value={brandId} key={brandId}>
                  {brandList[brandId]?.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="categoryId" label="类目">
            <CategorySelect leafOnly placeholder="类目" style={{ width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="id" label="标品ID">
            <Input placeholder="标品ID" allowClear />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="productId" label="商品ID">
            <Input placeholder="商品ID" allowClear />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="nameCN" label="中文名称">
            <Input placeholder="中文名称" allowClear />
          </Form.Item>
        </Col>
        <Col span={2} offset={1}>
          <Button type="primary" htmlType="submit">
            查询
          </Button>
        </Col>
        <Col span={2}>
          <Button type="primary" onClick={addHandler}>
            新增
          </Button>
        </Col>
        <Col span={2}>
          <Button type="primary" onClick={importHandler}>
            导入
          </Button>
        </Col>
        <Col span={2}>
          <Button type="primary" onClick={viewTasksHandler} loading={pending}>
            任务列表
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

const mapStateToProps = store => {
  return {
    brandList: store.brands.brandList,
  }
}

export default connect(mapStateToProps)(Header)